import React, { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { UserIcon, ArrowLeftOnRectangleIcon, Bars3Icon } from '@heroicons/react/24/outline';

interface HeaderProps {
  onMenuClick: () => void; // Para móvil
  onDesktopToggle: () => void; // Para escritorio
  isDesktopCollapsed: boolean;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, onDesktopToggle, isDesktopCollapsed }) => {
  const { currentUser, logout } = useContext(AppContext);

  return (
    <header className="bg-[#27272A] border-b border-white/5 p-4 flex justify-between items-center flex-shrink-0 z-20 shadow-sm">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="md:hidden p-2 -ml-2 text-white/80 hover:bg-white/10 rounded-lg transition-colors"
          title="Menú"
        >
          <Bars3Icon className="h-6 w-6" />
        </button>
        <button
          onClick={onDesktopToggle}
          className="hidden md:block p-2 text-white/60 hover:text-brand-accent hover:bg-white/10 rounded-lg transition-colors"
          title={isDesktopCollapsed ? "Expandir menú" : "Contraer menú"}
        >
          <Bars3Icon className="h-7 w-7" />
        </button>
        <h1 className="text-xl font-black text-white tracking-tight hidden sm:block">
          Monitor de Consumo <span className="text-brand-accent">Industrial</span>
        </h1>
        <h1 className="text-lg font-black text-brand-accent sm:hidden">M.C.I.</h1>
      </div>
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <UserIcon className="h-6 w-6 text-brand-accent" />
          <div className="text-right hidden sm:block">
            <p className="font-semibold text-white leading-tight">{currentUser?.name}</p>
            <p className="text-xs text-white/60">{currentUser?.role}</p>
          </div>
        </div>
        <button
          onClick={logout}
          className="flex items-center space-x-2 p-2 rounded-xl text-white/60 hover:bg-red-500/20 hover:text-red-400 transition-colors"
          title="Cerrar Sesión"
        >
          <ArrowLeftOnRectangleIcon className="h-6 w-6" />
        </button>
      </div>
    </header>
  );
};

export default Header;
